module.exports = __webpack_public_path__ + "static/img/teaser4.2cbbf40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teaser4.png
// module id = uJqA
// module chunks = 0